<template>
  <div class="PreviewMacChrome" :class="{ 's-hasMenu': hasMenu, 's-hasTwoActions': hasTwoActions, 's-hasIcon': hasIcon, 's-dark': dark }" @mouseover="showActions = true" @mouseout="showActions = false;">
      <div class="Background" @click="defaultAction"></div>
      <div class="AppIcon"></div>
      <div class="Details">
          <div class="Title" v-html="titleSmall"></div>
          <div class="Url" v-html="base.domain"></div>
          <div class="Body" v-html="bodySmall"></div>
      </div>
      <div v-if="hasIcon" class="Icon" :style="{'backgroundImage': 'url(' + base.icon + ')'}"></div>
      <transition name="fade">
        <div v-if="showActions" class="Actions">
          <div class="ActionFader"></div>
          <div class="ActionClose Action">{{$t('Close')}}</div>
          <div class="ActionMore Action" v-html="moreOrSettings" @click="openMenu"></div>
        </div>
      </transition>
      <div v-if="hasMenu && showMenu" class="Menu">
        <div class="MenuAction" @click="firstAction" v-html="action1TextSmall"></div>
        <div v-if="base.action2TextSmall" class="MenuAction" @click="secondAction" v-html="action2TextSmall"></div>
        <div class="MenuSettings">{{$t('Settings')}}</div>
      </div>
  </div>
</template>

<script>

import Utils from '../classes/Utils.class'

export default {
  name: 'PreviewMacChrome',
  props: {
    base: Object,
    dark: Boolean
  },
  data() {
    return {
      showActions: false,
      showMenu: false
    }
  },
  computed: {
    moreOrSettings() {
      return this.hasMenu ? this.$t('More') + '&or;' : this.$t('Settings')
    },
    hasActions() {
      return true
    },
    hasOnlyClose() {
      return true
    },
    hasMenu() {
      return !!this.base.action1TextSmall
    },
    hasIcon() {
      return !!this.base.icon
    },
    hasTwoActions() {
      return this.base.action1TextSmall && this.base.action2TextSmall
    },
    titleSmall() {
      if (this.dark) {
        return Utils.wrapEmojis(this.base.titleSmall, '<span class="emoji">', '</span>')
      }
      return this.base.titleSmall
    },
    bodySmall() {
      if (this.dark) {
        return Utils.wrapEmojis(this.base.bodySmall, '<span class="emoji">', '</span>')
      }
      return this.base.bodySmall
    },
    action1TextSmall() {
      if (this.dark) {
        return Utils.wrapEmojis(this.base.action1TextSmall, '<span class="emoji">', '</span>')
      }
      return this.base.action1TextSmall
    },
    action2TextSmall() {
      if (this.dark) {
        return Utils.wrapEmojis(this.base.action2TextSmall, '<span class="emoji">', '</span>')
      }
      return this.base.action2TextSmall
    }
  },
  methods: {
    defaultAction() {
      if (this.base.actionDefaultUrl) {
        // window.open(this.base.actionDefaultUrl)
      }
    },
    firstAction() {
      if (this.base.action1Url) {
        // window.open(this.base.action1Url)
      }
    },
    secondAction() {
      if (this.base.action2Url) {
        // window.open(this.base.action2Url)
      }
    },
    openMenu() {
      if (this.hasMenu) {
        this.showMenu = !this.showMenu
      }
    }
  }
}
</script>

<style scoped lang="less">
  .PreviewMacChrome {
    width: 344px;
    height: 63px;
    position: relative;
    font-family: 'Lucida Grande', 'Lucida Sans Unicode', sans-serif;
    &.s-hasMenu {
      height: 153px !important;
    }
    user-select: none;
  }
  .AppIcon, .Details, .Icon {
    pointer-events: none;
  }
  .Background {
    position: absolute;
    width: 344px;
    height: 63px;
    background: #ebebe9;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(204, 204, 204, .2);
  }
  .AppIcon {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 16px;
    left: 11px;
    background: url(../assets/icon-mac-chrome.png) center center no-repeat;
    background-size: 100%;
  }
  .Icon {
    width: 43px;
    height: 43px;
    position: absolute;
    top: 10px;
    right :10px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .Details {
    position: absolute;
    left: 52px;
    top: 7px;
    & > div {
      width: 280px;
      height: 15.7px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .Title {
      font-size: 12px;
      height: 17.14px;
    }
    .Url {
      font-size: 11px;
    }
    .Body {
      font-size: 11px;
    }
  }
  .s-hasIcon .Details > div {
    width: 215px;
  }
  .Actions {
    position: absolute;
    right: -1px;
    top: 0;
    width: 70px;
    height: 63px;
    border-left: 1px solid #d4d3d2;
    text-align: center;
    font-size: 12px;
    color: #646464;
    background: #ebebe9;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    .ActionFader {
      position: absolute;
      background: green;
      height: 63px;
      width: 50px;
      top: 0;
      left: -51px;
      background: linear-gradient(to right, rgba(235,235,233,0) 0%,rgba(235,235,233,1) 72%);
    }
    .ActionClose {
      height: 31px;
      border-bottom: 1px solid #d4d3d2;
      border-top-right-radius: 6px;
    }
    .ActionMore {
      height: 32px;
      border-bottom-right-radius: 6px;
    }
    & > div.Action {
      padding-top: 7px;
      //cursor: pointer;
      &:hover {
        background: #006fff;
        color: #fff;
      }
    }
  }
  .Menu {
    position: absolute;
    bottom: 27px;
    right: 0px;
    width: 87px;
    height: 62px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background: #ebebe9;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(204, 204, 204, .2);
    font-size: 12px;
    color: #646464;
    .MenuAction {
      border-bottom: 1px solid #d4d3d2;
      height: 30px;
      overflow: hidden;
    }
    .MenuSettings {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    & > div {
      padding-top: 6px;
      padding-bottom: 6px;
      //cursor: pointer;
      text-align: center;
      &:hover {
        background: #006fff;
        color: #fff;
      }
    }
  }
  .s-dark {
    .Background {
      background: #5e6163;
      transition: background .5s;
    }
    .Actions {
      background: #5e6163;
      color: #ffffff;
      border-left-color: #525254;
      .ActionClose {
        border-bottom-color: #525254;
      }
      .ActionFader {
        background: linear-gradient(to right, rgba(235,235,233,0) 0%,rgba(100, 100, 100,1) 72%);
      }
      & > div:hover {
        background: #252525;
      }
    }
    .Menu {
      color: #fff;
      background: #5e6163;
      border-color: #525254;
      .MenuAction, .MenuSettings {
        border-color: #525254;
      }
      & > div:hover {
        background: #252525;
      }
    }
  }
  .s-hasTwoActions .Menu {
    height: 90px;
    bottom: 0px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
<style lang="less">
  .PreviewMacChrome {
    &.s-dark {
      color: #fff;
      span.emoji {
        transition: filter .5s;
        filter: brightness(160%) contrast(140%);
      }
    }
  }
</style>
